var catalogList = new (function () {
  this.catalogId = "";
  this.createCatalogUrl = "";
  this.toggleMenu = function (obj) {
    obj.classList.toggle("active");
  };

  this.showPopup = function (obj) {
    if (obj.classList.contains("delete")) {
      catalogList.catalogId = obj.attributes["data-catalogId"].value;
      catalogList.deleteUrl = obj.attributes["data-deleteUrl"].value;
      document
        .querySelector(".catalogue-list-popup")
        .classList.add("catalogue-list-popup--confirm");
      return false;
    }
    if (obj.classList.contains("open")) {
      catalogList.catalogId = obj.attributes["data-catalogId"].value;
      catalogList.createCatalogUrl =
        obj.attributes["data-createCatalogUrl"].value;
      catalogList.copyUrl = obj.attributes["data-copyUrl"].value;
      document.querySelector("#list-edit").attributes["href"].value =
        obj.attributes["href"].value;
      document
        .querySelector(".catalogue-list-popup")
        .classList.add("catalogue-list-popup--open");
      return false;
    }
    document.querySelector("#url").value = obj.attributes["data-href"].value;
    document
      .querySelector(".catalogue-list-popup")
      .classList.add("catalogue-list-popup--url");
    return false;
  };

  this.confirmDelete = function (obj) {
    deleteCatalog(catalogList.catalogId);
  };

  this.confirmCopy = function (obj) {
    copyCatalog(
      catalogList.catalogId,
      catalogList.createCatalogUrl,
      catalogList.copyUrl
    );
  };

  this.hidePopup = function () {
    document
      .querySelector(".catalogue-list-popup")
      .classList.remove(
        "catalogue-list-popup--url",
        "catalogue-list-popup--confirm",
        "catalogue-list-popup--open"
      );
  };

  this.copyLink = function () {
    var copyTextarea = document.querySelector("#url");
    copyTextarea.focus();
    copyTextarea.select();

    try {
      var successful = document.execCommand("copy");
      //for logging purposes in case something fails.
      //var msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {}
  };
})();

var deleteCatalog = function (catalogId) {
  $.ajax({
    url: catalogList.deleteUrl + catalogId,
    type: "Delete",
  }).done(function () {
    location.reload();
  });
};

var copyCatalog = function (catalogId, catalogCreatorUrl, copyUrl) {
  $.ajax({
    url: copyUrl + catalogId,
    type: "Put",
  }).done(function (data) {
    window.open(catalogCreatorUrl + data, "_blank");
  });
};
